import React from "react";
import { Dropdown, Icon } from "@optimizely/axiom";

import styles from "./more-menu.module.scss";

export const MoreMenu = ({ children }: { children: any }) => {
    return (
        <Dropdown
            buttonContent={<Icon name="ellipsis-stroke" size="small" data-cy="more-menu-icon" />}
            className={styles["more-menu"]}
            testSection="more-menu"
            data-cy="more-menu"
        >
            <Dropdown.Contents data-cy="more-menu-contents">{children}</Dropdown.Contents>
        </Dropdown>
    );
};

MoreMenu.displayName = "MoreMenu";
